/**
 * 建议反馈
 */
import React from 'react';
import { Input, Row, Col, Tooltip, Icon } from 'antd';
import PageLayout from '../../ui/PageLayout';
import FeedbackEdit from "./FeedbackEdit";
import { global_data } from '../../ui/auth'

class FeedbackIndex extends React.Component {

  columns = [{
    title: '提交人',
    dataIndex: 'name',
    width: '10%',
  }, {
    title: '提交时间',
    dataIndex: 'insertTime',
    width: '10%',
  }, {
    title: '处理状态',
    dataIndex: 'status',
    width: '10%',
    format: { "0": "未处理", "1": "已知晓", "2": "已处理" }
  }, {
    title: '处理人',
    dataIndex: 'handleUser',
    width: '10%',
  }, {
    title: '建议',
    dataIndex: 'content',
    width: '50%',
  }, {
    title: '操作',
    dataIndex: 'id',
    width: '10%',
    render: (text, record, index) => (
      <div>
        {/* <Tooltip title="详细">
                  <Icon type="detail" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
              </Tooltip> */}
        {global_data.authCode.includes("SYS_FEEDBACK_HANDLE")?
        <Tooltip title="处理意见">
          <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
        </Tooltip>
        :""}
      </div>
    )
  }];

  state = {
    queryData: {},
    visible: false,
    editData: {}
  }

  inputSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["name"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData)
  }

  //修改
  update = (info, e) => {
    this.setState({ editData: info, visible: true });
  }
  hiddenModal = () => {
    this.setState({ visible: false });
  };



  render() {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <PageLayout
          condition={(
            <Row>
              <Col span={24}>
                <Input.Search
                  placeholder="提交人"
                  onSearch={this.inputSearch}
                  enterButton
                  style={{ width: '300px', marginRight: '10px' }}
                />
              </Col>
            </Row>
          )}
          rowKey="id"
          url="/feedback/findFeedbackPage"
          columns={this.columns}
          loadData={(func) => { this.setState({ loadData: func }) }}
        />
        <FeedbackEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
          queryData={this.state.queryData}
        />
      </div>
    )
  }



}

export default FeedbackIndex;